// NPM Dependencies
import * as angular from 'angular';

//SixPlus Dependencies (Modules)
import StatefulLoadingScreenComponent from './stateful-loading-screen.component';

export default angular.module('shared.loaders', [])
  .component('statefulLoadingScreen', StatefulLoadingScreenComponent)
  .name;
